import { render, staticRenderFns } from "./SelectCityArea.vue?vue&type=template&id=09049c18&"
import script from "./SelectCityArea.vue?vue&type=script&lang=js&"
export * from "./SelectCityArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports